module.exports = "https://www.gc-pro.gnp.com.mx/e923ec65b80707aa40c116e6d66ea771.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-lista-normal.svg
// module id = 973
// module chunks = 0